import { graphql } from '@/gql';

export const GET_VERTRAEGE_BY_STANDORTID = graphql(`
  query getVertraege($standortId: String!) {
    vertraegeByIdStandort(standortId: $standortId) {
      id
      kundennummer
      unternehmensname
      aktiveAnzahl
      vereinbarteAnzahl
      vertragTarif
      vertragIntervall
      faelligkeitsdatum
      preisModell
      vertragstatus
      summeNetto {
        waehrung
        wert
      }
      vertragZahlungsmethode
    }
  }
`);
